<template>
  <v-container>
    <v-tabs
      v-model="tab"
      slider-color="secondary"
      color="primary"
      background-color="transparent"
      active-class="secondary"
    >
      <v-tab>{{$t('Documents.List.header')}}</v-tab>
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="documentsList"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-dialog v-model="showCategories" max-width="700px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2 mr-3" v-on="on">{{$t('Documents.Button.editCategories')}}</v-btn>
                </template>
                <DocumentCategories class="pa-3"/>
              </v-dialog>
              <v-dialog v-model="showEditor" max-width="700px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('Documents.Button.add')}}</v-btn>
                </template>
                <DocumentEditor
                  ref="documentEditor"
                  :defaultDocument="editedIndex >= 0 ? documentsList[editedIndex] : null"
                  :formTitle="editedIndex >= 0 ? 'Modification' : 'Création'"
                  @save="save"
                  @cancel="close"
                />
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.fileSize="{ item }">
            {{ getHumanBytes(item.fileSize) }}
          </template>
          <template v-slot:item.isVisible="{ item }">
            <v-icon v-if="item.isVisible" color="success">visibility</v-icon>
            <v-icon v-else color="error">visibility_off</v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn fab small icon :href="getDocumentPath(item.id)" color="primary">
              <v-icon small>cloud_download</v-icon>
            </v-btn>
            <v-btn fab small icon @click="editItem(item)" color="primary">
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn fab small icon @click="deleteItem(item)" color="primary">
              <v-icon small>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import DocumentEditor from '@/components/Document/DocumentEditor'
import documentsService from '@/services/documents'
import prettyBytes from 'pretty-bytes'
import FilesPathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
import DocumentCategories from '@/components/Document/DocumentCategories'
export default {
  components: { DocumentEditor, DocumentCategories },
  mixins: [FilesPathHelpersMixin],
  data: () => ({
    tab: null,
    documentsList: [],
    showEditor: false,
    showCategories: false,
    editedIndex: -1,
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('Documents.Form.title'),
          align: 'left',
          value: 'title',
        },
        { text: this.$t('Documents.Form.fileName'), value: 'fileName' },
        { text: this.$t('Documents.Form.size'), value: 'fileSize' },
        { text: this.$t('Documents.Form.mall'), value: 'mall.name' },
        { text: this.$t('Documents.Form.category'), value: 'category.title' },
        { text: this.$t('Documents.Form.visibility'), value: 'isVisible' },
        { sortable: false, value: 'actions', width: '200px' },
      ]
    }
  },

  watch: {
    showEditor (val) {
      val || this.close()
    }
  },

  methods: {
    async load () {
      this.documentsList = await documentsService.getAll()
    },
    async save (document) {
      if (this.editedIndex > -1) {
        try {
          const updatedDocument = await documentsService.update(document)
          this.documentsList.splice(this.editedIndex, 1, updatedDocument)
          this.close()
        } catch (error) {
          this.$store.dispatch('errorMessage', this.$t('Message.Error.update'))
        }
      } else {
        try {
          const newDocument = await documentsService.create(document)
          this.documentsList.push(newDocument)
          this.close()
        } catch (error) {
          this.$store.dispatch('errorMessage', this.$t('Message.Error.create'))
        }
      }

    },
    async deleteItem (document) {
      const valid = confirm(this.$t('Documents.Message.delete'))
      if (valid) {
        await documentsService.delete(document.id)
        const index = this.documentsList.indexOf(document)
        this.documentsList.splice(index, 1)
      }
    },
    editItem (document) {
      this.editedIndex = this.documentsList.indexOf(document)
      this.showEditor = true
    },
    close () {
      this.showEditor = false
      this.$refs.documentEditor.resetForm()
      setTimeout(() => {
        this.editedIndex = -1
      }, 300)
    },
    getHumanBytes (bytes) {
      return prettyBytes(bytes)
    }
  },

  created () {
    this.load()
  }
}
</script>
